export const normalizePassportNumber = (passportNumber: string | number): string => {
  // Convert to string and clean up
  const cleaned = String(passportNumber)
    .trim()
    .replace(/\s+/g, '') // Remove all whitespace
    .replace(/[^\w\d]/g, ''); // Remove special characters
    
  return cleaned;
};

const formatPassportNumber = (passportNumber: string | number): string => {
  return String(passportNumber).trim();
};

const validatePassportNumber = (passportNumber: string | number): boolean => {
  const formatted = formatPassportNumber(passportNumber);
  return formatted.length > 0;
};